import { get } from 'lodash';

import { DashboardVehicle } from '../types/DashboardVehicle';

export const getVehicleApplicationType = (vehicle: DashboardVehicle) => {
  return get(vehicle, 'application.type');
};
